export default class VoicesArchive {
  constructor() {
    this.root = null;
    this.progress = null;
    this.track = null;
    this.current = null;
    this.scope = null;
    this.bindUpdate = this.update.bind(this);
    this.cacheElements();
  }

  start() {
    if (!this.progress || !this.track || !this.current || !this.scope) return;
    window.addEventListener("scroll", this.bindUpdate, { passive: true });
    window.addEventListener("resize", this.bindUpdate);
    this.update();
  }

  reset() {
    this.destruct();
    this.cacheElements();
    this.start();
  }

  destruct() {
    window.removeEventListener("scroll", this.bindUpdate);
    window.removeEventListener("resize", this.bindUpdate);
    if (this.progress) {
      this.progress.style.transform = "";
    }
  }

  update() {
    if (!this.progress || !this.track || !this.current || !this.scope) return;

    const viewportHeight = window.innerHeight;
    const trackHeight = this.track.clientHeight;
    if (trackHeight <= 0) return;

    const scrollY = window.scrollY;
    const scopeTop = this.scope.getBoundingClientRect().top + scrollY;
    const scopeHeight = this.scope.offsetHeight;
    const scrollStart = scopeTop;
    const scrollEnd = Math.max(scopeTop + scopeHeight - viewportHeight, scopeTop);

    const scrollRange = scrollEnd - scrollStart;
    const scopeRatio = scopeHeight > 0 ? viewportHeight / scopeHeight : 1;
    const thumbRatio = Math.min(Math.max(scopeRatio, 0), 1);
    const thumbHeight = Math.max(Math.round(trackHeight * thumbRatio), 24);
    const clampedThumbHeight = Math.min(thumbHeight, trackHeight);

    const progress =
      scrollRange > 0
        ? Math.min(Math.max((scrollY - scrollStart) / scrollRange, 0), 1)
        : 0;
    const maxTravel = trackHeight - clampedThumbHeight;
    const thumbTop = maxTravel * progress;
    const progressTop =
      parseFloat(window.getComputedStyle(this.progress).top) || 0;
    const progressHeight = this.progress.offsetHeight;
    const progressBottomOffset =
      (parseFloat(window.getComputedStyle(document.documentElement).fontSize) ||
        0) * 5;
    const scopeBottom = scopeTop + scopeHeight;
    const minProgressTop = scopeTop;
    const maxProgressTop = Math.max(
      minProgressTop,
      scopeBottom - progressHeight - progressBottomOffset
    );
    const targetProgressTop = scrollY + progressTop;
    const clampedProgressTop = Math.min(
      Math.max(targetProgressTop, minProgressTop),
      maxProgressTop
    );
    const progressOffset = clampedProgressTop - targetProgressTop;

    this.progress.style.transform = `translate3d(0, ${progressOffset}px, 0)`;
    this.current.style.height = `${clampedThumbHeight}px`;
    this.current.style.transform = `translateY(${thumbTop}px)`;
  }

  cacheElements() {
    this.root = document.querySelector("main.voices");
    if (!this.root) return;

    this.progress = this.root.querySelector(".js-voices-page-progress");
    this.track = this.progress
      ? this.progress.querySelector(".voices-page-progress__track")
      : null;
    this.current = this.progress
      ? this.progress.querySelector(".js-voices-page-progress-current")
      : null;
    this.scope =
      this.root.querySelector(".js-voices-progress-scope") ||
      this.root.querySelector(".content-content") ||
      this.root.querySelector(".voices-grid") ||
      this.root;
  }
}
